import React from "react";
import PropTypes from "prop-types";
import ConstrainedSelect from "./ConstrainedSelect";
import { getMessage } from "../data/locales";
import { buildAnnouncementCourseFilterOptions } from "../utils/filterAnnouncementsByCourse";

function AnnouncementCourseFilter({ value, courses, onChange }) {
  return (
    <label className="ga-course-filter" htmlFor="ga-list-course-filter">
      <span>{getMessage("announcements.filterCourseLabel")}</span>
      <ConstrainedSelect
        id="ga-list-course-filter"
        className="ga-select ga-course-filter-select"
        value={value}
        ariaLabel={getMessage("announcements.filterCourseLabel")}
        onChange={onChange}
        options={[
          { value: "", label: getMessage("announcements.filterCourseAll") },
          ...buildAnnouncementCourseFilterOptions(courses),
        ]}
      />
    </label>
  );
}

export default AnnouncementCourseFilter;

AnnouncementCourseFilter.propTypes = {
  value: PropTypes.string.isRequired,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      titulo: PropTypes.string,
      nombre: PropTypes.string,
    }).isRequired,
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};
